import { RightOutlined } from "@ant-design/icons";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";

import * as theme from "./LargeMenuItem.css";

// Made to work with Radix UI DropdownMenu
// Can be split off to be used outside Radix UI DropdownMenu if needed
interface ItemContentProps {
    titleLabel: string;
    descriptionLabel?: string;
    href?: HTMLAnchorElement["href"];
    target?: HTMLAnchorElement["target"];
    onClick?: () => void;
}
export function LargeMenuItem({
    titleLabel,
    descriptionLabel,
    href,
    onClick,
    target = "_blank",
}: ItemContentProps) {
    const content = (
        <>
            <div>
                <div>{titleLabel}</div>
                {descriptionLabel && (
                    <div className={theme.description}>{descriptionLabel}</div>
                )}
            </div>
            <RightOutlined className={theme.icon} />
        </>
    );

    const Component = href ? "a" : "div";
    const props = href ? { href, target } : { onClick };

    return (
        <DropdownMenu.Item className={theme.root} asChild={!!href}>
            <Component className={theme.content} {...props}>
                {content}
            </Component>
        </DropdownMenu.Item>
    );
}
